import { DocumentNode } from 'graphql'

export const resolveOperationNames = (documentNodes: DocumentNode[]) =>
  documentNodes.map(
    (documentNode: any) =>
      documentNode.definitions?.[0]?.name?.value ?? 'not_found',
  )
